import { render } from "./ProgressCreate.vue?vue&type=template&id=5e037d2c"
import script from "./ProgressCreate.vue?vue&type=script&lang=js"
export * from "./ProgressCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__